export default __webpack_public_path__ + "d8e5cd3bf1ad97708d28d0face45933d.png";